export default "__VITE_ASSET__dSQJdIUD__"